@if(showNavbar){
  <div class="main-nav">
    <div class="upp-navbar d-grid">
      <div><img src="assets/svg/logo-orange.svg" alt="" style="width: 50%;"></div>
      <div class="npt-nav-search-bar d-grid">
        <div><img src="assets/svg/search.svg" alt=""></div>
        <input type="text" class="npt-nav-search" placeholder="Buscar...">
      </div>

      <div class="nav-iconsnav d-flex">
        <img src="assets/svg/more-options-icon.svg" alt="Más" class="nav-iconnav">
        <div class="notification-container">
          <img src="assets/svg/notification-bell-icon.svg" 
               alt="Notificaciones" 
               class="nav-iconnav notification-bell" 
               (click)="toggleNotifications()"
               style="cursor: pointer;">
          <!-- Badge de notificaciones no leídas -->
          @if(unreadNotificationsCount > 0) {
            <span class="notification-badge">{{ unreadNotificationsCount }}</span>
          }
        </div>
        <img src="assets/svg/avatar.svg" alt="Usuario" class="nav-iconnav" style="width: 40px; height: 40px;">
        <span class="nav-usernamenva">{{ activeUserName }}</span>
        <img src="assets/svg/logout-icon.svg" alt="Cerrar sesión" class="nav-iconnav" 
             (click)="logout()" style="cursor: pointer;">
      </div>
    </div>

    <div class="low-navbar">
      <ul>
        <!-- Items principales siempre visibles -->
        @for(item of mainNavItems; track item.item){
          <li [ngClass]="{'nav-item-active' : item.active, 'nav-item': !item.active}">
            <a [routerLink]="item.route">{{ item.name }}</a>
          </li>
        }
        
        <!-- Menú "Más" con dropdown -->
        <li class="nav-item-more" [ngClass]="{'nav-item-active': activeMoreItem}">
          <div class="more-dropdown-container" (click)="$event.stopPropagation()">
            <a class="more-toggle" 
               (click)="toggleMoreDropdown($event)" 
               [ngClass]="{'active': showMoreDropdown}">
              Más
              <svg class="dropdown-arrow" 
                   [ngClass]="{'rotated': showMoreDropdown}"
                   width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                <path d="M7 10l5 5 5-5z"/>
              </svg>
            </a>
          </div>
        </li>
      </ul>
      
      <!-- Dropdown del menú "Más" fuera del navbar para evitar problemas de z-index -->
      @if(showMoreDropdown) {
        <div class="more-dropdown-overlay" (click)="closeMoreDropdown()">
          <div class="more-dropdown" 
               [style.top]="dropdownPosition.top"
               [style.left]="dropdownPosition.left"
               [style.right]="dropdownPosition.right"
               (click)="$event.stopPropagation()">
            @for(item of moreNavItems; track item.item) {
              <a class="dropdown-item" 
                 [ngClass]="{'active': item.active}"
                 (click)="navigateToMoreItem(item)">
                {{ item.name }}
              </a>
            }
          </div>
        </div>
      }
    </div>

    <!-- Componente de notificaciones -->
    <app-notifications 
      [isVisible]="showNotifications"
      (closePanel)="closeNotifications()"
      (createNewGoal)="onCreateNewGoal()">
    </app-notifications>
  </div>
}